<template>
  <b-dialog :name="'application-download'" width="750" @closed="clearData">
    <form class="uk-form-horizontal b-form" autocomplete="off" @submit.prevent="">
      <div v-if="errorMessage" class="uk-alert-danger uk-animation-slide-bottom-small" uk-alert>
        <p>{{ errorMessage }}</p>
      </div>
      <Spinner :isLoading="isLoading">
        <div class="uk-flex uk-flex-middle uk-margin-small-bottom">
          <label class="form-column--left application-column--left" for="start-date"
            >Дата начала <span class="req-star">*</span></label
          >
          <div class="form-column--right">
            <b-datepicker
              v-model="voteStartDate"
              id="start-date"
              ref="datepickerStart"
              name="meeting-start"
              :class="{'uk-form-danger uk-animation-shake': $v.voteStartDate.$error}"
            />
          </div>
        </div>
        <div class="uk-flex uk-flex-middle uk-margin-small-bottom">
          <label class="form-column--left application-column--left" for="end-date"
            >Дата окончания <span class="req-star">*</span></label
          >
          <div class="form-column--right">
            <b-datepicker
              v-model="voteEndDate"
              id="end-date"
              ref="datepickerEnd"
              name="meeting-end"
              :disabled-date="disabledBeforeToday"
              :class="{'uk-form-danger uk-animation-shake': $v.voteEndDate.$error}"
              :disabled="!voteStartDate"
              @close="validError"
            />
          </div>
        </div>
        <div class="uk-flex uk-margin-small-bottom">
          <label class="form-column--left application-column--left"
            >По ТС сущ. в системе "Мой Дом" <span class="req-star top">*</span></label
          >
          <div class="form-column--right radio-group uk-flex-wrap">
            <b-radio v-model="isRegistered" :value="true" name="type" :checked="isRegistered">
              Да
            </b-radio>
            <b-radio v-model="isRegistered" :value="false" name="type" :checked="!isRegistered">
              Нет
            </b-radio>
          </div>
        </div>
        <div class="uk-flex uk-margin-medium-bottom">
          <label class="form-column--left application-column--left"
            >Статус заявки <span class="req-star">*</span></label
          >
          <div class="form-column--right">
            <v-select v-model="status" :options="statusList" class="status-select" />
          </div>
        </div>
        <div class="uk-flex uk-flex-center">
          <b-button
            name="Сохранить"
            color="red"
            class="margin-right_60"
            :disabled="$v.$error"
            @click="download"
          />
          <b-button name="Отменить" @click="$modal.hide('application-download')" />
        </div>
      </Spinner>
    </form>
  </b-dialog>
</template>

<script>
import {required} from 'vuelidate/lib/validators'
import {fileDownload} from '@/common/utils/file-download'
import {showSuccess} from '@/common/utils/notification'

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

import {mapActions} from 'vuex'

export default {
  name: 'DownloadForm',
  data: () => ({
    voteStartDate: '',
    voteEndDate: '',
    errorMessage: '',
    isLoading: false,
    isRegistered: false,
    status: {
      label: 'на рассмотрении',
      code: 'INIT'
    },
    statusList: [
      {
        label: 'на рассмотрении',
        code: 'INIT'
      },
      {
        label: 'принято',
        code: 'ACCEPTED'
      },
      {
        label: 'отказано',
        code: 'REJECTED'
      }
    ]
  }),
  components: {
    vSelect
  },
  methods: {
    ...mapActions({
      downloadApplication: 'application/DOWNLOAD_APPLICATION'
    }),
    download() {
      this.$v.$touch()
      if (!this.$v.$error) {
        let formData = {
          dateFrom: this.toFormattedDate(this.voteStartDate),
          dateTo: this.toFormattedDate(this.voteEndDate),
          isRegistered: this.isRegistered,
          status: this.status.code
        }

        this.isLoading = true
        this.downloadApplication(formData)
          .then(resp => {
            fileDownload(resp)
            this.isLoading = false
            showSuccess('Выгрузка документа успешно завершена')
            this.$modal.hide('application-download')
          })
          .catch(() => {
            this.errorMessage = 'Неизвестная ошибка. Обратитесь к администратору'
            this.isLoading = false
          })
      } else {
        this.errorMessage = 'Выберите дату!'
      }
    },
    disabledBeforeToday(date) {
      return date.getTime() < new Date(this.voteStartDate).getTime()
    },
    toFormattedDate(date) {
      let day = ('0' + date.getDate()).slice(-2)
      let month = ('0' + (date.getMonth() + 1)).slice(-2)
      let year = date.getFullYear()
      return year + '-' + month + '-' + day
    },
    validError() {
      if (this.voteStartDate) {
        this.errorMessage = ''
      }
    },
    clearData() {
      this.errorMessage = ''
      this.$v.$reset()
      this.voteStartDate = ''
      this.voteEndDate = ''
      this.status = {
        label: 'на рассмотрении',
        code: 'INIT'
      }
      this.isRegistered = false
    }
  },
  validations: {
    voteStartDate: {
      required
    },
    voteEndDate: {
      required,
      minValue() {
        return new Date(this.voteEndDate).getTime() >= new Date(this.voteStartDate).getTime()
      }
    }
  }
}
</script>
